const PRODUCT_IMAGE_KEYS = [
  "productImage",
  "product_image",
  "primaryImageUrl",
  "primary_image_url",
  "imageUrl",
  "image_url",
  "image",
  "thumbnailUrl",
  "thumbnail_url",
  "thumbnail",
  "images",
  "imageUrls",
  "image_urls",
  "imageURLs",
  "productImages",
  "product_images",
  "photos",
] as const;

const LEGACY_GENERIC_SEED_PRODUCT_IMAGE_MARKERS = [
  "photo-1486262715619-67b85e0b08d3",
  "photo-1760317890314-e964ffd7e6a6",
  "photo-1764869427601-eb699ac80a0c",
  "photo-1632733711679-529326f6db12",
  "photo-1764847997209-1b7df695c120",
] as const;

const LEGACY_V5_SEED_PRODUCT_IMAGE_URLS = new Set(
  [
    "https://upload.wikimedia.org/wikipedia/commons/7/76/Brake_pads.JPG",
    "https://upload.wikimedia.org/wikipedia/commons/0/05/Disc_brakes.jpg",
    "https://upload.wikimedia.org/wikipedia/commons/9/93/Air_filter_for_Toyota_1KR-FE.jpg",
    "https://upload.wikimedia.org/wikipedia/commons/c/cb/Engine_oil_filter.JPG",
    "https://upload.wikimedia.org/wikipedia/commons/1/1f/Car_fuel_pre-filter.jpg",
    "https://upload.wikimedia.org/wikipedia/commons/7/7e/Philips_Xtreme_Power_headlight_bulb.JPG",
    "https://upload.wikimedia.org/wikipedia/commons/3/30/KYB_shock_low.jpg",
    "https://upload.wikimedia.org/wikipedia/commons/d/dc/McPherson-Federbein.jpg",
    "https://upload.wikimedia.org/wikipedia/commons/f/f5/Catalytic_converter_20230510.jpg",
    "https://upload.wikimedia.org/wikipedia/commons/0/08/Car_Outer_Rear_View_Mirror.jpg",
    "https://upload.wikimedia.org/wikipedia/commons/1/16/Automotive_coolant_pump_6C1Q-8K500-AF-3357.jpg",
    "https://upload.wikimedia.org/wikipedia/commons/3/3e/Automotive_alternator._Terminals.jpg",
    "https://upload.wikimedia.org/wikipedia/commons/c/c8/Fuelpump.jpg",
    "https://upload.wikimedia.org/wikipedia/commons/8/84/Wheel_hub_assembly.jpg",
    "https://upload.wikimedia.org/wikipedia/commons/7/7f/MOTOR_STARTER.jpg",
    "https://upload.wikimedia.org/wikipedia/commons/1/10/Clutch_disc_1.jpg",
    "https://upload.wikimedia.org/wikipedia/commons/a/ad/Automobile_radiator.jpg",
  ].map((value) => value.toLowerCase()),
);

const SPARELYNK_PRODUCT_IMAGE_MARKERS = [
  "/icons/sparelynk-512.png",
  "/icons/sparelynk-192.png",
  "/icons/sparelynk-maskable-512.png",
  "/icons/sparelynk-favicon",
  "/sparelynk-og.png",
  "/assets/logo.png",
  "/assets/logo.webp",
  "/assets/images/logo.png",
  "color2_mainlogo_300x.png",
] as const;

const SEEDED_PRODUCT_SKUS = new Set([
  "BRK-PAD-FRONT-001",
  "LED-HL-BULB-002",
  "ENG-AIR-FLTR-003",
  "STRUT-FR-004",
  "CAT-CONV-005",
  "MIRROR-L-USED-006",
  "TESTSELLER-QA-BRK-VIOS-001",
]);

const SEEDED_VENDOR_NAMES = new Set([
  "metro auto parts",
  "prime gear garage",
  "testing seller",
]);

const SEEDED_ORDER_NUMBERS = new Set([
  "SL-1001",
  "SL-1002",
  "SL-1003",
  "SL-1004",
  "SL-1005",
  "SL-1006",
]);

const SEED_PRODUCT_IMAGE_MATCHES = [
  { path: "https://images.unsplash.com/photo-1763679112092-053a6eadd72f?auto=format&fit=crop&w=1200&q=80", keywords: ["fuel filter"] },
  { path: "https://images.unsplash.com/photo-1777118947168-b6e806cb80cf?auto=format&fit=crop&w=1200&q=80", keywords: ["oil filter"] },
  {
    path: "https://images.unsplash.com/photo-1522598140461-ec9911e01c53?auto=format&fit=crop&w=1200&q=80",
    keywords: ["air filter", "cabin filter", "engine filter"],
  },
  {
    path: "https://images.unsplash.com/photo-1613214150384-14921ff659b2?auto=format&fit=crop&w=1200&q=80",
    keywords: [
      "brake rotor",
      "brake disc",
      "brake disk",
      "disc brake",
      "disk brake",
      "rotor",
    ],
  },
  { path: "https://images.unsplash.com/photo-1696494561430-de087dd0bd69?auto=format&fit=crop&w=1200&q=80", keywords: ["brake pad"] },
  { path: "https://images.unsplash.com/photo-1595787142842-7404bc60470d?auto=format&fit=crop&w=1200&q=80", keywords: ["water pump"] },
  { path: "https://images.unsplash.com/photo-1779263569890-ce0389630b10?auto=format&fit=crop&w=1200&q=80", keywords: ["fuel pump"] },
  {
    path: "https://images.unsplash.com/photo-1643933871541-090062935680?auto=format&fit=crop&w=1200&q=80",
    keywords: ["wheel bearing", "wheel hub", "hub assembly"],
  },
  {
    path: "https://images.unsplash.com/photo-1758411897917-5c959de7291e?auto=format&fit=crop&w=1200&q=80",
    keywords: ["headlight", "headlamp"],
  },
  { path: "https://images.unsplash.com/photo-1760836395763-25ea44ae8145?auto=format&fit=crop&w=1200&q=80", keywords: ["strut"] },
  {
    path: "https://images.unsplash.com/photo-1760836395716-7dd00b71311a?auto=format&fit=crop&w=1200&q=80",
    keywords: ["shock absorber", "shock"],
  },
  {
    path: "https://images.unsplash.com/photo-1759419281480-bacc913c9606?auto=format&fit=crop&w=1200&q=80",
    keywords: ["catalytic converter", "catalytic"],
  },
  {
    path: "https://images.unsplash.com/photo-1590520745369-36d668d1ae20?auto=format&fit=crop&w=1200&q=80",
    keywords: ["side mirror", "door mirror", "mirror"],
  },
  { path: "https://images.unsplash.com/photo-1757547570448-04946db22218?auto=format&fit=crop&w=1200&q=80", keywords: ["alternator"] },
  {
    path: "https://images.unsplash.com/photo-1614447428943-52ec0bdbc7aa?auto=format&fit=crop&w=1200&q=80",
    keywords: ["starter motor", "starter"],
  },
  {
    path: "https://images.unsplash.com/photo-1609682932589-5ef2bd85980d?auto=format&fit=crop&w=1200&q=80",
    keywords: ["clutch disc", "clutch disk", "clutch plate", "clutch kit", "clutch"],
  },
  { path: "https://images.unsplash.com/photo-1771192048787-a57c81a82d1d?auto=format&fit=crop&w=1200&q=80", keywords: ["radiator"] },
] as const;

const PRODUCT_DESCRIPTOR_KEYS = new Set([
  "title",
  "name",
  "productname",
  "category",
  "categoryname",
  "key",
  "sku",
  "code",
  "partnumber",
  "productnumber",
  "vehiclemodel",
]);

const SKU_KEYS = new Set(["sku", "productsku"]);
const ORDER_NUMBER_KEYS = new Set(["ordernumber"]);
const SEED_SCOPE_KEYS = new Set(["seedscope"]);
const VENDOR_NAME_KEYS = new Set([
  "vendorname",
  "sellername",
  "storename",
  "businessname",
]);

type SeedImageMetadata = {
  descriptors: string[];
  skus: string[];
  orderNumbers: string[];
  seedScopes: string[];
  vendorNames: string[];
};

function normalizeMetadataKey(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9]/g, "");
}

function collectSeedImageMetadata(
  value: unknown,
  metadata: SeedImageMetadata,
  depth: number,
): void {
  if (depth > 4 || value === null || value === undefined) return;

  if (Array.isArray(value)) {
    value.forEach((entry) => collectSeedImageMetadata(entry, metadata, depth + 1));
    return;
  }

  if (typeof value !== "object") return;

  Object.entries(value as Record<string, unknown>).forEach(([key, entry]) => {
    const normalizedKey = normalizeMetadataKey(key);

    if (typeof entry === "string") {
      const text = entry.trim();
      if (!text) return;

      if (PRODUCT_DESCRIPTOR_KEYS.has(normalizedKey)) {
        metadata.descriptors.push(text);
      }
      if (SKU_KEYS.has(normalizedKey)) {
        metadata.skus.push(text);
      }
      if (ORDER_NUMBER_KEYS.has(normalizedKey)) {
        metadata.orderNumbers.push(text);
      }
      if (SEED_SCOPE_KEYS.has(normalizedKey)) {
        metadata.seedScopes.push(text);
      }
      if (VENDOR_NAME_KEYS.has(normalizedKey)) {
        metadata.vendorNames.push(text);
      }
      return;
    }

    if (typeof entry === "object" && entry !== null) {
      collectSeedImageMetadata(entry, metadata, depth + 1);
    }
  });
}

function isSeededImageContext(metadata: SeedImageMetadata): boolean {
  if (
    metadata.skus.some((sku) => {
      const normalized = sku.trim().toUpperCase();
      return normalized.startsWith("CAT-") ||
        normalized.startsWith("TESTSELLER-") ||
        SEEDED_PRODUCT_SKUS.has(normalized);
    })
  ) {
    return true;
  }

  if (
    metadata.orderNumbers.some((orderNumber) => {
      const normalized = orderNumber.trim().toUpperCase();
      return (
        SEEDED_ORDER_NUMBERS.has(normalized) ||
        normalized.startsWith("TEST-AERO-ORDER-") ||
        normalized.startsWith("TEST-FBS-ORDER-") ||
        normalized.startsWith("SL-CD-") ||
        normalized.startsWith("RPT-")
      );
    })
  ) {
    return true;
  }

  if (
    metadata.seedScopes.some((scope) => {
      const normalized = scope.trim().toLowerCase();
      return normalized.includes("seed") || normalized.includes("demo") || normalized.includes("report");
    })
  ) {
    return true;
  }

  return metadata.vendorNames.some((name) =>
    SEEDED_VENDOR_NAMES.has(name.trim().toLowerCase()),
  );
}

export function getSeedProductImageFallback(...values: unknown[]): string {
  const metadata: SeedImageMetadata = {
    descriptors: [],
    skus: [],
    orderNumbers: [],
    seedScopes: [],
    vendorNames: [],
  };
  values.forEach((value) => collectSeedImageMetadata(value, metadata, 0));

  if (!isSeededImageContext(metadata)) return "";

  const haystack = metadata.descriptors.join(" ").trim().toLowerCase();
  for (const match of SEED_PRODUCT_IMAGE_MATCHES) {
    if (match.keywords.some((keyword) => haystack.includes(keyword))) {
      return match.path;
    }
  }

  if (haystack.includes("filter")) return "https://images.unsplash.com/photo-1522598140461-ec9911e01c53?auto=format&fit=crop&w=1200&q=80";
  if (haystack.includes("brake")) return "https://images.unsplash.com/photo-1696494561430-de087dd0bd69?auto=format&fit=crop&w=1200&q=80";
  if (haystack.includes("bearing")) return "https://images.unsplash.com/photo-1643933871541-090062935680?auto=format&fit=crop&w=1200&q=80";
  return "https://images.unsplash.com/photo-1763836393413-3b79e6b4560a?auto=format&fit=crop&w=1200&q=80";
}

export function isValidProductImageUrl(value: unknown): value is string {
  if (typeof value !== "string") return false;
  const url = value.trim();
  if (!url) return false;

  const normalized = url.toLowerCase();
  if (normalized.includes("placehold.co") || normalized.includes("placeholder")) {
    return false;
  }
  if (LEGACY_V5_SEED_PRODUCT_IMAGE_URLS.has(normalized)) {
    return false;
  }
  if (
    LEGACY_GENERIC_SEED_PRODUCT_IMAGE_MARKERS.some((marker) =>
      normalized.includes(marker),
    )
  ) {
    return false;
  }
  return !SPARELYNK_PRODUCT_IMAGE_MARKERS.some((marker) =>
    normalized.includes(marker),
  );
}

function collectProductImageUrls(
  value: unknown,
  output: string[],
  seen: Set<string>,
  depth: number,
): void {
  if (depth > 4 || value === null || value === undefined) return;

  if (typeof value === "string") {
    const url = value.trim();
    if (!isValidProductImageUrl(url)) return;
    const key = url.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    output.push(url);
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((entry) => collectProductImageUrls(entry, output, seen, depth + 1));
    return;
  }

  if (typeof value !== "object") return;
  const record = value as Record<string, unknown>;
  PRODUCT_IMAGE_KEYS.forEach((key) => {
    if (key in record) {
      collectProductImageUrls(record[key], output, seen, depth + 1);
    }
  });

  if (depth > 0) {
    for (const key of ["url", "src"] as const) {
      if (key in record) {
        collectProductImageUrls(record[key], output, seen, depth + 1);
      }
    }
  }
}

export function normalizeProductImageUrls(...values: unknown[]): string[] {
  const output: string[] = [];
  const seen = new Set<string>();
  values.forEach((value) => collectProductImageUrls(value, output, seen, 0));

  if (output.length === 0) {
    const fallback = getSeedProductImageFallback(...values);
    if (fallback) output.push(fallback);
  }

  return output;
}

export function selectPrimaryProductImage(...values: unknown[]): string {
  return normalizeProductImageUrls(...values)[0] ?? "";
}
